export default "__VITE_ASSET__30aa8987__"